import { getIdReduxUtil, getValueReduxUtil } from '../../../../redux'
import { PLAN_KEY } from '../../constants'

function isAuthorPlanUtil (plan, profile) {
  const authorId = getValueReduxUtil(plan, PLAN_KEY.AUTHOR_ID)
  const profileId = getIdReduxUtil(profile)
  if (authorId) {
    return authorId === profileId
  }
  return getValueReduxUtil(plan, PLAN_KEY.PROFILE_ID) === profileId
}

export {
  isAuthorPlanUtil
}
